class Adherent {
  loginAdherent() {
    const keyCloakLoginNational = `${drupalSettings.urlNationalSite}sso-autoconnect?redirectToMember`;

    if (!document.body.classList.contains('user-logged-in')) {
      const buttons = document.querySelectorAll('.btn-login-adherent, nav#block-espacepersonnel ul.menu>li:first-child, #block-votreespacepersonnel a.btn')
      const openIdForm = document.getElementById('openid-connect-login-form');

      buttons.forEach(button => {
        button.addEventListener('click', e => {
          e.preventDefault();
          if (openIdForm) {
            openIdForm.submit();
          } else if (keyCloakLoginNational) {
            window.location.href = keyCloakLoginNational;
          }
        })
      });
    }
  }

  sideBarAbonnements() {
    $(window).on('load', function () {
      $('aside.layout-sidebar-right').prepend('<h2>Mes abonnements</h2>');
    });
  }
}

export default Adherent;
